import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/utils/registerSW";
import { installAuthInterceptor } from "@/utils/apiInterceptor";

// Install the atomic silent-refresh interceptor BEFORE React mounts so the
// very first /auth/me call (fired by AuthContext on mount) is already wired
// for rolling-refresh recovery.
installAuthInterceptor();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Promote the page to an installable PWA so Chromium relaxes intensive
// background-tab throttling on the YouTube iframes.
registerServiceWorker();
